import { render, staticRenderFns } from "./AttachmentGallery.vue?vue&type=template&id=4540c955&scoped=true"
import script from "./AttachmentGallery.vue?vue&type=script&lang=js"
export * from "./AttachmentGallery.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGallery.vue?vue&type=style&index=0&id=4540c955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29._80ed213f6ba743306e514f7b7b6c1c5b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540c955",
  null
  
)

export default component.exports